import { AbstractConstructor, enforceArray, exists } from '@treasury/utils';
import { LitElement, adoptStyles } from 'lit';
// @ts-expect-error - Allowing typescript to ignore this line so it works for both webpack and vite
import baseStyles from '../styles/styles.css?inline';

export const StyleMixin = <T extends AbstractConstructor<LitElement>>(superClass: T) => {
    abstract class StyleMixin extends superClass {
        public connectedCallback() {
            super.connectedCallback();
            if (this.renderRoot && this.renderRoot instanceof ShadowRoot) {
                const subclass = Object.getPrototypeOf(this).constructor;
                const subclassStyles = exists(subclass.styles) ? enforceArray(subclass.styles) : [];
                adoptStyles(this.renderRoot, [baseStyles, ...subclassStyles]);
            }
        }
    }
    return StyleMixin;
};
